import React from "react";
import { Link } from "react-router-dom";
import Page from "../components/Page";
import { useLang } from "../i18n/LanguageContext";
import usePageMeta from "../hooks/usePageMeta";

export default function About() {
  const { lang } = useLang();
  const sq = lang === "sq";
  usePageMeta(sq ? "Rreth nesh — Amora Weddings" : "About — Amora Weddings");

  return (
    <Page
      title={sq ? "Rreth nesh" : "About us"}
      subtitle={
        sq
          ? "Një vend i vetëm për gjithçka që ju nevojitet për dasmën tuaj."
          : "One place for everything you need for your wedding."
      }
    >
      {sq ? (
        <>
          <p>
            <strong>Amora Weddings</strong> lindi nga një ide e thjeshtë: planifikimi i një dasme nuk duhet të
            jetë kaos mesazhesh, pyetjesh për çmime dhe kërkimesh të pafundme nëpër Instagram. Ne i sjellim
            bizneset më të mira të dasmave — salla, fotografë, dekorime, muzikë, grim, fustane e shumë më
            tepër — në një vend të vetëm.
          </p>
          <p>
            Jemi krijuar nga njerëz që e njohin nga afër botën e dasmave dhe të përmbajtjes. E dimë se çfarë i
            bën çiftet të ndalen, çfarë i bën dasmat të duken të mrekueshme, dhe sa e vështirë është për një
            biznes të vogël të dalë para syve të çiftit të duhur.
          </p>
          <h2>Çfarë na bën të ndryshëm</h2>
          <ul>
            <li>I përqendruar te tregu shqiptar — Kosovë, Shqipëri dhe më gjerë.</li>
            <li>Bizneset zgjidhen me kujdes, jo një listë e pafund pa kuptim.</li>
            <li>Kontakt i drejtpërdrejtë: telefono, shkruaj në WhatsApp ose Instagram, pa ndërmjetës.</li>
            <li>Falas për çiftet, gjithmonë.</li>
          </ul>
          <h2>Misioni ynë</h2>
          <p>
            Të bëjmë planifikimin e dasmës më të lehtë për çiftet, dhe të ndihmojmë bizneset lokale të rriten
            duke u lidhur me çiftet që kanë vërtet nevojë për ta.
          </p>
          <p>
            Je biznes dasmash? <Link to="/list">Regjistrohu këtu</Link>. Ke pyetje?{" "}
            <Link to="/contact">Na kontakto</Link>.
          </p>
        </>
      ) : (
        <>
          <p>
            <strong>Amora Weddings</strong> started from a simple idea: planning a wedding shouldn't be a chaos
            of DMs, price questions and endless Instagram searching. We bring the best wedding businesses —
            venues, photographers, decoration, music, makeup, dresses and more — into one place.
          </p>
          <p>
            We're built by people who know the world of weddings and content closely. We understand what makes
            couples stop and look, what makes a wedding feel unforgettable, and how hard it is for a small
            business to get in front of the right couple.
          </p>
          <h2>What makes us different</h2>
          <ul>
            <li>Focused on the Albanian market — Kosovo, Albania and beyond.</li>
            <li>Businesses are curated, not an endless meaningless list.</li>
            <li>Direct contact: call, WhatsApp or Instagram, with no middleman.</li>
            <li>Free for couples, always.</li>
          </ul>
          <h2>Our mission</h2>
          <p>
            To make wedding planning easier for couples, and to help local businesses grow by connecting them
            with the couples who genuinely need them.
          </p>
          <p>
            Are you a wedding business? <Link to="/list">List here</Link>. Have a question?{" "}
            <Link to="/contact">Get in touch</Link>.
          </p>
        </>
      )}
    </Page>
  );
}
